export const getAtsUserFullName = (user = {}) =>
  [user?.first_name, user?.middle_name, user?.last_name]
    .map(part => String(part || "").trim())
    .filter(Boolean)
    .join(" ")
    .trim()

export const mapAtsUsersToOptions = (payload = {}) => {
  const users = Array.isArray(payload?.users)
    ? payload.users
    : Array.isArray(payload?.results)
    ? payload.results
    : Array.isArray(payload)
    ? payload
    : []

  return users.map(user => {
    const name = getAtsUserFullName(user) || user?.email || "User"
    const id = user?.id ?? user?.user_id ?? user?.unique_user_id ?? null

    return {
      ...user,
      id,
      value: id,
      label: name,
      name,
      email: user?.email || "",
      phone_number: user?.phone_number || "",
      role_name: user?.hrms_role__hrms_role_name || user?.role_name || "",
    }
  })
}
